import cn from '../../lib/cn';
import Reveal from './Reveal';

/** Eyebrow + title + description block used at the top of every section. */
export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  tone = 'light',
  className,
  children,
}) {
  const centered = align === 'center';
  const dark = tone === 'dark';

  return (
    <Reveal
      className={cn(
        'max-w-3xl',
        centered && 'mx-auto text-center',
        className
      )}
    >
      {eyebrow && <span className={dark ? 'eyebrow-dark' : 'eyebrow'}>{eyebrow}</span>}
      <h2
        className={cn(
          'mt-5 text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-[2.6rem]',
          dark && 'text-white'
        )}
      >
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            'mt-4 text-base leading-relaxed sm:text-lg',
            dark ? 'text-brand-100/85' : 'text-ink-500'
          )}
        >
          {description}
        </p>
      )}
      {children}
    </Reveal>
  );
}
